import React from "react";
import { Source, Layer } from "react-map-gl";

interface ClusterLayerProps {
  data: GeoJSON.FeatureCollection; // GeoJSON data
  clusterMaxZoom?: number; // Optional: max zoom for clustering
  clusterRadius?: number; // Optional: radius of clustering
}

const ClusterLayer: React.FC<ClusterLayerProps> = ({
  data,
  clusterMaxZoom = 14,
  clusterRadius = 99,
}) => {
  return (
    <>
      {/* GeoJSON Source with clustering enabled */}
      <Source
        id="clusters"
        type="geojson"
        data={data}
        cluster={true}
        clusterMaxZoom={clusterMaxZoom}
        clusterRadius={clusterRadius}
      >
        <Layer
          id="clusters-layer"
          type="circle"
          filter={['has', 'point_count']}
          paint={{
            'circle-color': [
              'step',
              ['get', 'point_count'],
              '#EFF8FC',
              10,
              '#EFF8FC',
              20,
              '#EFF8FC',
            ],
            'circle-stroke-color': 'grey',
            'circle-stroke-width': 2,
            'circle-radius': ['step', ['get', 'point_count'], 20, 10, 30, 20, 40]
          }}
        />
        <Layer
          id="cluster-count-layer"
          type="symbol"
          filter={['has', 'point_count']}
          layout={{
            'text-field': '{point_count_abbreviated}',
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
            'text-size': 20,
          }}
        />
        {/* Unclustered points layer */}
        <Layer
          id="unclustered-layer"
          type="circle"
          filter={['!', ['has', 'point_count']]}
          paint={{
            'circle-color': '#EFF8FC',
            'circle-radius': 10,
            'circle-stroke-width': 2,
            'circle-stroke-color': 'grey',
          }}
        />
      </Source>
    </>
  );
};

export default ClusterLayer;